export default __webpack_public_path__ + "a43870cd59a753ec939f3af764c53304.svg";